const STORAGE_KEY = "get-token-ui";

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isGetTokenRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/gettoken" || path.startsWith("/gettoken/");
};

export const loadGetTokenPersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveGetTokenPersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist get token state", error);
  }
};

export const clearGetTokenPersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getPersistedGetTokenUiState = () => {
  const data = loadGetTokenPersistence();
  if (!data) {
    return {
      hasCache: false,
      selectedProductId: null,
      containtedQty: 1,
      products: [],
      totalQuantityRemaining: null,
      selectedProduct: null
    };
  }

  const products = Array.isArray(data.products) ? data.products : [];
  const selectedProductId = data.selectedProductId ?? null;
  const normalizedSelectedId =
    selectedProductId == null || selectedProductId === ""
      ? null
      : String(selectedProductId);
  const selectedProduct =
    normalizedSelectedId != null
      ? products.find((product) => String(product.id) === normalizedSelectedId) || null
      : null;

  return {
    hasCache: Boolean(
      products.length > 0 || data.totalQuantityRemaining !== null || selectedProductId != null
    ),
    selectedProductId,
    containtedQty: Number(data.containtedQty) > 0 ? Number(data.containtedQty) : 1,
    products,
    totalQuantityRemaining:
      data.totalQuantityRemaining !== null && data.totalQuantityRemaining !== undefined
        ? data.totalQuantityRemaining
        : null,
    selectedProduct
  };
};
